// T021: Create Steemit client wrapper

import { Client } from '@steempro/dsteem'

// Multiple node URLs for failover
const STEEMIT_NODES = [
  'https://api.steemit.com',
  'https://api.steemyy.com',
  'https://rpc.amarbangla.net',
]

// Create singleton client instance
let clientInstance: Client | null = null

export function getSteemitClient(): Client {
  if (!clientInstance) {
    clientInstance = new Client(STEEMIT_NODES, {
      timeout: 5000,
      failoverThreshold: 4,
      consoleOnFailover: import.meta.env.DEV,
    })
  }
  return clientInstance
}

// Reset client (useful for testing)
export function resetClient(): void {
  clientInstance = null
}
